<template>
  <ViewWrapper>
    <div v-if="isProcessing">
      <h1>
        Verifying...
      </h1>
    </div>

    <div v-else-if="isVerified">
      <div class="text">
        <h1>
          Email address confirmed
        </h1>

        <p>
          Your email address has been confirmed, you can now continue to the Cashflo app.
        </p>
      </div>

      <ButtonLink
        url="cashflo://email_verified"
      >
        Open Cashflo
      </ButtonLink>

      <p>
        <small>Open the Cashflo App</small>
      </p>
    </div>

    <div v-else>
      <h1>
        Something went wrong
      </h1>

      <p v-if="getRequestError()">
        {{getRequestError()}}
      </p>

      <p
        v-for="([key, value]) in getFieldErrors()"
        :key="key"
      >
        {{value}}
      </p>
    </div>
  </ViewWrapper>
</template>

<script>
  import EmailAPI from '@/api/EmailAPI'

  import RequestMixin from '@/mixins/RequestMixin'

  import ButtonLink from '@/components/ButtonLink'
  import ViewWrapper from '@/components/ViewWrapper'

  export default {
    mixins: [
      RequestMixin,
    ],

    components: {
      ButtonLink,
      ViewWrapper,
    },

    data() {
      return {
        isVerified: false,
      }
    },

    methods: {
      async verifyEmail() {
        const { emailVerificationCode, email } = this.$route.query

        await EmailAPI.verifyEmail(email, {
          emailVerificationCode,
        })

        this.isVerified = true
      },
    },

    mounted() {
      this.handleRequest(this.verifyEmail)
    },
  }
</script>

<style scoped lang="scss">
  .text {
    margin-bottom: 30px;
  }
</style>
